import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { opApiRequest } from 'src/api/apiRequest';
import sendPostMessage from 'src/store/app/operation/sendPostMessage';
import { MESSAGE_TYPE } from 'src/store/app/types';
import { Store } from 'src/store/index';
import findCustomerPictureId from 'src/util/embroidery/findCustomerPictureId';

interface ColorEntry {
  from: string;
  to: string;
}

interface ColorReplacementRequest {
  assetId: string;
  colors: {
    fill: ColorEntry[];
    stroke: ColorEntry[];
  };
  quantized: boolean;
  variantKey: string | undefined;
  designOptionKey: string | undefined;
  threadColors?: string[];
}

interface RecolorResponse {
  url: string;
}

const handleAssetColorReplacementOperation = (request: ColorReplacementRequest) => async (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  try {
    const customerPictureId = findCustomerPictureId(getState(), request.assetId);
    if (!customerPictureId) {
      return;
    }

    const colorMap = [
      ...(request.colors.fill || []),
      ...(request.colors.stroke || []),
    ];

    if (colorMap.length === 0) {
      return;
    }

    const response = await opApiRequest(
      '/api/customer/gallery/v1/image/recolor',
      { customerPictureId: Number(customerPictureId), colorMap },
      'data',
      'POST',
    ) as RecolorResponse;

    sendPostMessage({
      type: MESSAGE_TYPE['asset.setAssetWithReplacedColors'],
      data: {
        assetId: request.assetId,
        url: response.url,
        colors: request.colors,
        variantKey: request.variantKey,
        designOptionKey: request.designOptionKey,
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[OP-39631] Color replacement failed:', error);
  }
};

export default handleAssetColorReplacementOperation;
